import * as React from "react";
const SvgChevronLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 12, viewBox: "0 0 8 12", fill: "#FFFFFF", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.70504 10.59L3.12504 6L7.70504 1.41L6.29504 0L0.295044 6L6.29504 12L7.70504 10.59Z" }));
export default SvgChevronLeft;
